import React, { useContext } from "react";
import { Form, FormGroup, Label, Input, Button, Row, Col } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import UserContext from "../auth/UserContext";
import "./AddLocationForm.css";

const validationSchema = Yup.object({
    name: Yup.string().required("Region name is required"),
});

const AddRegionForm = () => {
    const { addRegion } = useContext(UserContext);

    const formik = useFormik({
        initialValues: { name: "" },
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const result = await addRegion(values.name);
            if (result?.success) {
                resetForm();
            }
        },
    });

    return (
        <Row className="justify-content-center add-location-page">
            <Col
                xs={12}
                md={7}
                lg={6}>
                <Form
                    className="add-location-form"
                    onSubmit={formik.handleSubmit}>
                    <FormGroup className="add-location-group">
                        <Label htmlFor="name">Region Name</Label>
                        <Input
                            className="add-location-input add-region-input"
                            id="name"
                            name="name"
                            type="text"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.name && Boolean(formik.errors.name)}
                        />
                        {formik.touched.name && formik.errors.name && <div className="invalid-feedback">{formik.errors.name}</div>}
                    </FormGroup>
                    <Button
                        color="primary"
                        className="add-location-submit"
                        type="submit">
                        Add Region
                    </Button>
                </Form>
            </Col>
        </Row>
    );
};

export default AddRegionForm;
